import axiosInstance from "@/api";
import { API_ROUTES } from "@/constants/api-routes";
import { IAdminLogsResponse, IAdminLogsParams } from "@/api/types/admin-logs";
import { serializeObject } from "@/utils/serializer";

export const GetAdminLogs = async (params: Partial<IAdminLogsParams> = {}) => {
    // Transform parameters to ensure proper filter structure
    const transformedParams: any = {
        skip: params.skip,
        take: params.take,
        search: params.search,
    };

    // Handle filter object
    if (params.filter) {
        const filterParams: any = {};

        // Only include non-empty filter values
        if (params.filter.entity) filterParams.entity = params.filter.entity;
        if (params.filter.action) filterParams.action = params.filter.action;
        if (params.filter.userId) filterParams.userId = params.filter.userId;
        if (params.filter.startDate) filterParams.startDate = params.filter.startDate;
        if (params.filter.endDate) filterParams.endDate = params.filter.endDate;
        if (params.filter.isError !== undefined) filterParams.isError = params.filter.isError;

        // Only add filter if it has any values
        if (Object.keys(filterParams).length > 0) {
            transformedParams.filter = filterParams;
        }
    }

    // Debug log to verify filter structure
    console.log("Admin Logs API Request:", transformedParams);

    const queryString = Object.keys(transformedParams).length > 0 ? `?${serializeObject(transformedParams)}` : "";

    const result = await axiosInstance.get<IAdminLogsResponse>(`${API_ROUTES.ADMIN_LOGS.LIST}${queryString}`);

    return result.data;
};
